import { render, staticRenderFns } from "./QuoteDetailsDia.vue?vue&type=template&id=2870ab7e&scoped=true&"
import script from "./QuoteDetailsDia.vue?vue&type=script&lang=js&"
export * from "./QuoteDetailsDia.vue?vue&type=script&lang=js&"
import style0 from "./QuoteDetailsDia.vue?vue&type=style&index=0&id=2870ab7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2870ab7e",
  null
  
)

export default component.exports